<template>
  <div class="login-page">
    <router-link :to="landingPath" class="close-btn" :aria-label="$t('common.close')">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </router-link>
    <LoginForm />
  </div>
</template>

<script>
import LoginForm from "@/components/auth/LoginForm"

export default {
  components: { LoginForm },
  computed: {
    landingPath() {
      return this.$route.path.startsWith('/en') ? '/en' : '/'
    },
  },
}
</script>

<style lang="scss" scoped>
.login-page {
  position: relative;
  min-height: 100vh;
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  color: #496782;
  text-decoration: none;
  transition: background 0.2s, transform 0.2s;
  z-index: 100;

  &:hover {
    background: #fff;
    transform: scale(1.1);
  }

  svg {
    width: 24px;
    height: 24px;
  }
}
</style>
